<template>
    <div style="display: flex; justify-content: center; align-items: center; height: 70vh; flex-direction: column">
        <h2>Add city</h2>
        <div style="max-width: 200px;" class="add-city-card">
            <loader v-if="loading" style="max-height: 200px"></loader>
            <div v-else>
                <el-form label-position="left">
                <el-form-item label="City">
                    <el-input style="padding: 10px 0" v-model="city_name" placeholder="City">Add city</el-input>
                </el-form-item>
                </el-form>
                <el-button style="width: 100%" type="primary" @click="addCity">Add</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import CityService from '@/common/services/city.service'
    import Loader from "../common/components/loader";

    export default {
        name: 'AddCity',
        components: {Loader},
        data() {
            return {
                city_name: null,
                loading: false
            }
        },

        methods: {
            addCity() {
                this.loading = true;
                CityService.addCity(this.city_name).then(() => {
                    this.$notify.success({
                        title: `City`,
                        message: `Successfully added city`
                    });
                }).catch(error => {
                    this.$notify.error({
                        title: `Failed to add city`,
                        message: error.response.data.message
                    });
                }).finally(() => this.loading = false)

            }
        }
    }
</script>

<style scoped>
    .add-city-card {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        bottom: 0;
        background-color: white;
        border-radius: 5px;
        min-width: 400px;
        padding: 20px;
        -webkit-box-shadow: 0 0 5px #c7c1c1
    }
</style>
